export default __webpack_public_path__ + "static/media/secure.89c929f6.png";